const React = require('react');
const {AdminSubtitle} = require('../../../../../dumb/AdminHelpers/AdminLayout');
const RoutingFields = require('./components/RoutingFields');
const BaseTrxCurrency = require('./components/BaseTrxCurrency');
const {PROCESSING_SCHEMA} = require("./utils");
const openPopupUpdate = require("./utils/openPopupUpdate");
const openPopupReset = require("./utils/openPopupReset");

const {FormFooter, FormWrapper} = require('../../../../../dumb/FormHandlers');
const noop = require("mn-utils/noop");
const {PAYMENT_METHODS_LIST} = require("../../../../../../constants/paymentMethods");

module.exports = ({
  data,
  initialErrors,
  onSubmit = noop,
  onResult = noop,
  disabledCurrencySelect,
  onGlobalClick,
  disabledGlobal
}) => {

  const defaultData = PAYMENT_METHODS_LIST.reduce((acc, method) => {
    acc[method.id] = data[method.id] || 'none';
    return acc;
  }, {fiat_code: data['fiat_code']})

  return (
    <FormWrapper
      data={defaultData}
      errors={initialErrors}
      schema={PROCESSING_SCHEMA}
      onSubmit={(data) => {
        const payload = PAYMENT_METHODS_LIST.reduce((acc, method) => {
          if (data[method.id] !== 'none') acc[method.id] = data[method.id];
          return acc;
        }, {fiat_code: data['fiat_code']});

        return new Promise((onResult) => {
          openPopupUpdate({payload, onSubmit, onResult})
        });
      }}
      onResult={onResult}
      disableFormAfterSubmit
    >
      {(formCtx) => {
        return (
          <>
            <BaseTrxCurrency
              formCtx={formCtx}
              disabled={disabledCurrencySelect}
            />
            <div className="mt49">
              <AdminSubtitle text="ROUTING PROFILE" />
            </div>
            <RoutingFields formCtx={formCtx} />
            <FormFooter
              className="mb25"
              submitBtnData={{
                text: 'Save Configuration',
                formCtx
              }}
              additionalBtnsList={
                onGlobalClick
                  ? [{
                      text: 'Reset to Global',
                      onClick: () => openPopupReset(onGlobalClick),
                      disabled: disabledGlobal
                    }]
                  : []
              }
            />
          </>
        )
      }}
    </FormWrapper>
  )
}
